/**
 * Sincroniza la variante (color/talla) elegida en el selector del producto
 * con los selectores de variante que EasySell renderiza dentro de su
 * formulario COD, para que aparezca ya elegida al abrirlo.
 */
(function () {
  /** @returns {Record<string, string>} Nombre de opción (en mayúsculas) -> valor seleccionado */
  function getPageSelectedOptions() {
    var picker = document.querySelector('variant-picker');
    if (!picker) return {};

    var options = {};

    picker.querySelectorAll('select').forEach(function (select) {
      var selected = select.selectedOptions[0];
      var name = selected && selected.dataset && selected.dataset.optionName;
      if (name) options[name.trim().toUpperCase()] = selected.value;
    });

    picker.querySelectorAll('fieldset input:checked').forEach(function (input) {
      var name = input.dataset && input.dataset.optionName;
      if (name) options[name.trim().toUpperCase()] = input.value;
    });

    return options;
  }

  /** @returns {number | null} Cantidad de pares elegida en el bloque de oferta combo de la página. */
  function getPageSelectedComboQty() {
    var selectedBtn = document.querySelector(
      '.combo-offer__option.is-selected, .combo-offer__option[aria-pressed="true"]'
    );
    if (!selectedBtn) return null;

    var qty = selectedBtn.dataset ? selectedBtn.dataset.comboQty : null;
    if (!qty) qty = selectedBtn.getAttribute('data-combo-qty');

    var parsed = parseInt(qty, 10);
    return isNaN(parsed) ? null : parsed;
  }

  // Selecciona, dentro del formulario de EasySell, la tarjeta de oferta
  // ("1 PAR" / "2 PARES" / "3 PARES") que coincide con lo elegido en la
  // página, simulando el clic que haría el cliente.
  //
  // IMPORTANTE: solo se hace clic una vez por cada valor de comboQty nuevo.
  // Sin este freno, cada clic dispara una mutación en el DOM que nuestro
  // propio listener/observer vuelve a detectar, generando un clic tras otro
  // en bucle infinito y congelando la página.
  var lastClickedComboQty = null;

  // Sube desde el título de la oferta (".offer-title") hasta el elemento
  // que EasySell usa como tarjeta clicable de esa oferta: el hijo directo
  // de ".es-qo-container". EasySell no expone una clase propia estable
  // para esa tarjeta (es un <div> sin clase), así que la ubicamos por
  // posición en el árbol en vez de por selector CSS.
  function getOfferCard(titleEl) {
    var container = titleEl.closest('.es-qo-container');
    if (!container) return null;

    var card = titleEl;
    while (card && card.parentElement !== container) card = card.parentElement;
    return card;
  }

  function syncEasySellOffer() {
    var comboQty = getPageSelectedComboQty();
    if (!comboQty || comboQty === lastClickedComboQty) return;

    var titleEls = document.querySelectorAll('.offer-title');
    if (!titleEls.length) return;

    titleEls.forEach(function (titleEl) {
      var titleText = titleEl.textContent || '';
      var match = titleText.match(/(\d+)/);
      var offerQty = match ? parseInt(match[1], 10) : null;

      if (offerQty !== comboQty) return;

      var card = getOfferCard(titleEl);
      if (!card) return;

      lastClickedComboQty = comboQty;
      card.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    });
  }

  function syncEasySellForm() {
    var selects = document.querySelectorAll('select[id^="es-offer-variant-"]');
    if (!selects.length) return;

    var pageOptions = getPageSelectedOptions();
    if (!Object.keys(pageOptions).length) return;

    selects.forEach(function (select) {
      var label = select.previousElementSibling;
      var name = label && label.textContent && label.textContent.trim().toUpperCase();
      if (!name || !(name in pageOptions)) return;

      var value = pageOptions[name];
      var hasMatchingOption = Array.prototype.some.call(select.options, function (opt) {
        return opt.value === value;
      });
      if (!hasMatchingOption || select.value === value) return;

      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      select.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  // Reintenta varias veces: EasySell (Vue) puede re-renderizar los selects
  // del segundo/tercer par un instante después de que el cliente elige una
  // oferta de varios pares, y esa actualización puede pisar el valor que
  // ya habíamos sincronizado.
  function fullSync() {
    syncEasySellOffer();
    syncEasySellForm();
  }

  function scheduleSync() {
    fullSync();
    setTimeout(fullSync, 60);
    setTimeout(fullSync, 200);
    setTimeout(fullSync, 500);
    setTimeout(fullSync, 1000);
  }

  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('variant-picker')) {
      scheduleSync();
    }
  });

  // Cualquier clic en el selector de pares de la página, o dentro del
  // selector de ofertas / bloque de variantes de EasySell, dispara un
  // re-render que debemos volver a sincronizar.
  document.addEventListener(
    'click',
    function (event) {
      if (
        event.target.closest &&
        (event.target.closest('.combo-offer__option') ||
          event.target.closest('.es-qo-container') ||
          event.target.closest('.v-variants'))
      ) {
        scheduleSync();
      }
    },
    true
  );

  // Agrupa ráfagas de mutaciones del DOM (comunes en toda la página: animaciones,
  // carga diferida de imágenes, etc.) en una sola sincronización, en vez de
  // disparar el ciclo completo de reintentos por cada mutación individual.
  var debounceTimer = null;
  var observer = new MutationObserver(function () {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(scheduleSync, 100);
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'aria-pressed'],
    });
  }

  scheduleSync();
})();
